import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as diagnosisAdapter from '../_reducers/diagnosis.reducer';
import {diagnosisFeatureKey, DiagnosisState} from '../_reducers/diagnosis.reducer';
import {isEmpty} from 'lodash-es';
import {IDiagnosisIdNode} from '../_interface/diagnosisid-node.interface';

export const diagnosisEntityState = createFeatureSelector<DiagnosisState>(diagnosisFeatureKey);

export const selectEntities = createSelector(
	diagnosisEntityState,
	({entities}) => entities
);

export const selectAll = createSelector(
	diagnosisEntityState,
	(diagnosis) => Object.values(diagnosis.entities)
);

export const selectLoaded = createSelector(
	diagnosisAdapter.selectTotal,
	(total) => total
);

export const selectTotal = createSelector(
	diagnosisEntityState,
	({ids}) => ids.length
);

export const selectEntitiesAndTotal = createSelector(
	selectTotal,
	selectEntities,
	(total, entities) => ({total, entities})
);

export const selectTree = createSelector(
	diagnosisEntityState,
	({tree}) => tree
);

export const selectFlatTree = createSelector(
	diagnosisEntityState,
	({flatTree}) => flatTree
);

export const selectTrees = createSelector(
	selectTree, selectFlatTree,
	(tree, flat) => ({tree, flat})
);

export const selectDictWithFlatTree = createSelector(
	selectEntities,
	selectFlatTree,
	(dict, flatTree) => ({dict, flatTree})
);

export const selectDiagnosisRootIds = createSelector(
	selectTree,
	(tree) => Object.keys(tree)
);

export const selectDiagnosisIdTree = createSelector(
	diagnosisEntityState,
	({tree}): [string, any][] => {
		const getItems = (entries: IDiagnosisIdNode): [string, any][] =>
			Object.entries(entries)
				.map(([key, items]): any => {
					return isEmpty(items) ? [key] : [key, getItems(items)];
				}).filter(Boolean);
		return getItems(tree);
	}
);

export const selectDiagnosisFilter = createSelector(
	diagnosisEntityState, ({filter}) => filter
);

export const selectDiagnosisNodeById = (diagnosisId: string) => createSelector(
	selectEntities, (entities) => entities[diagnosisId]);

export const selectAllFavourites = createSelector(
	diagnosisEntityState, ({favourites}) => favourites);

export const selectDiagnosisFavourites = createSelector(
	selectAll, selectAllFavourites, (entities, allFavourites) => {
		const favFromEntities = entities.filter(({favourites}) => favourites);
		return [...new Map([...favFromEntities, ...allFavourites].map((diagnosis) => [diagnosis.diagnosisId, diagnosis])).values()];
	}
);

export const selectDiagnosisFavouritesAsDict = createSelector(
	selectDiagnosisFavourites, (favourites) => Object.assign({}, ...favourites.map((f) => ({[f.diagnosisId]: f})))
);

export const selectDiagnosisNodeFromEntitiesAndFavouritesById = (diagnosisId: string) => createSelector(
	selectEntities, selectDiagnosisFavouritesAsDict,
	(entities, favourites) => entities[diagnosisId] || favourites[diagnosisId]
);
